import img1 from '../Album/1.png';
import img2 from '../Album/2.png';
import img3 from '../Album/3.JPG';
import img4 from '../Album/4.jpg';
import img5 from '../Album/5.jpg';
import img6 from '../Album/6.jpg';
import img7 from '../Album/7.jpg';
import img8 from '../Album/8.jpg';
import img9 from '../Album/9.jpg';

export const PHOTO_ALBUM_IMAGES = [
  { src: img1, caption: 'Christmas – 2025' },
  { src: img2, caption: 'Wilmington Beach, NC – Summer 2023' },
  { src: img3, caption: 'Birthday – Raleigh, 2024' },
  { src: img4, caption: 'Myrtle Beach – Summer 2025' },
  { src: img5, caption: 'Best Friends – Qaen, Iran, 2017' },
  { src: img6, caption: 'Tomb of Aboozar Jemehr – Qaen, Iran' },
  { src: img7, caption: 'Best Saffron in the world – Qaen, Iran' },
  { src: img8, caption: 'Me and the best Cookie - 13 be dar 2025- An Iranian culture' },
  { src: img9, caption: 'Meet Sancho: part fluff, part sass, 100% heart thief.' },
];
